export function getSelectableLineSortKey(road = null) {
    return ["case",
        ["==", ["get", "road", ["at", 0, ["get", "linearLocation"]]], road],
        1,
        0,
    ]
}